/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

// Types
import { FailedCall } from '../../../shared/types/manageCalls';

// Environment
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class WebServiceCaller {
  private http = inject(HttpClient);

  private readonly WEBSERVICES_MODE = environment.WEBSERVICES_MODE as 'ONLINE' | 'LOCAL';
  private readonly WEB_SERVICE_URL = environment.WEBSERVICES[this.WEBSERVICES_MODE].WEB_SERVICE_URL;

  getCall<T = any>(resource: string): Observable<T> {
    const URL = this.buildUrl(resource);
    return this.http.get<T>(URL).pipe(catchError(this.errorHandle));
  }

  postCall<T = any>(resource: string, body: unknown = {}): Observable<T> {
    const URL = this.buildUrl(resource);
    return this.http.post<T>(URL, body).pipe(catchError(this.errorHandle));
  }

  postCallBuffer(resource: string, body: unknown = {}): Observable<HttpEvent<ArrayBuffer>> {
    const URL = this.buildUrl(resource);
    return this.http
      .post(URL, body, { responseType: 'arraybuffer', reportProgress: true, observe: 'events' })
      .pipe(catchError(this.errorHandle));
  }

  putCall<T = any | FailedCall>(resource: string, body: unknown = {}): Observable<T> {
    const URL = this.buildUrl(resource);
    return this.http.put<T>(URL, body).pipe(catchError(this.errorHandle));
  }

  // Error handling
  private errorHandle({ error }: { error: FailedCall }): Observable<never> {
    return throwError(() => error);
  }

  private buildUrl(resource: string): string {
    return [this.WEB_SERVICE_URL, '/', resource].join('');
  }
}
